import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import Toggle from "../../components/Toggle";
import { canSeeBrands } from "../../services/auth";

const BRAND_SEARCH_FROM = 7;

/**
 * Seção "Visibilidade do produto" do cadastro e da edição: onde o produto
 * aparece. Substituiu o "Ativo/Inativo" e as caixas "Marcas" / "Produto
 * exclusivo". Controlada: as escolhas só vão para o backend no "Salvar".
 */
export const ProductVisibility = ({ sites, quotable, onChange, disabled }) => {
    const navigate = useNavigate();
    const [brandSearch, setBrandSearch] = useState('');

    if (!sites) return null;

    const personalizedFor = sites.personalized_for;
    const showBrands = canSeeBrands() && sites.brands.length > 0;
    const term = brandSearch.trim().toLowerCase();
    const brands = term
        ? sites.brands.filter(brand => brand.name.toLowerCase().includes(term))
        : sites.brands;

    const setMainSite = value => onChange({ sites: { ...sites, main_site: value }, quotable });
    const setQuotable = value => onChange({ sites, quotable: value });
    const setBrand = (brandId, value) => onChange({
        sites: { ...sites, brands: sites.brands.map(brand => brand.id === brandId ? { ...brand, on_site: value } : brand) },
        quotable
    });

    return (
        <div className="product-visibility">
            <h2 className="section-title">Visibilidade do produto</h2>

            <div className="product-visibility-list">
                <div className="product-visibility-row">
                    <div>
                        <strong>Site principal</strong>
                        <span>
                            {personalizedFor
                                ? `Versão personalizada: aparece só no site da ${personalizedFor.name}`
                                : `${sites.main_site_domain ? `${sites.main_site_domain} e ` : ''}feed do Google/Meta`}
                        </span>
                    </div>
                    <Toggle
                        checked={sites.main_site}
                        disabled={disabled || Boolean(personalizedFor)}
                        label="Site principal"
                        onChange={setMainSite}
                    />
                </div>

                <div className="product-visibility-row">
                    <div>
                        <strong>Orçamentos pelo sistema</strong>
                        <span>Aparece na busca de produtos ao montar um orçamento</span>
                    </div>
                    <Toggle
                        checked={quotable}
                        disabled={disabled}
                        label="Orçamentos pelo sistema"
                        onChange={setQuotable}
                    />
                </div>

                {showBrands &&
                    <>
                        <div className="product-visibility-subtitle">
                            <span>Sites das marcas</span>
                            {sites.brands.length >= BRAND_SEARCH_FROM &&
                                <input
                                    type="text"
                                    placeholder="Buscar marca"
                                    value={brandSearch}
                                    onChange={e => setBrandSearch(e.target.value)}
                                />
                            }
                        </div>
                        {brands.map(brand => (
                            <div className="product-visibility-row brand" key={brand.id}>
                                <div>
                                    <strong>{brand.name}</strong>
                                    {brand.replaced_by
                                        ? <span>
                                            Substituído pela versão personalizada{' '}
                                            <button type="button" onClick={() => navigate(`/brand/${brand.id}/personalized/${brand.replaced_by.id}`)}>
                                                {brand.replaced_by.name}
                                            </button>
                                        </span>
                                        : brand.domain && <span>{brand.domain}</span>
                                    }
                                </div>
                                <Toggle
                                    checked={brand.on_site}
                                    disabled={disabled || Boolean(brand.replaced_by)}
                                    label={brand.name}
                                    onChange={value => setBrand(brand.id, value)}
                                />
                            </div>
                        ))}
                    </>
                }
            </div>
        </div>
    );
};

export const visibilityPayload = sites => sites
    ? {
        main_site: sites.main_site,
        brands: sites.brands.map(brand => ({ id: brand.id, on_site: brand.on_site }))
    }
    : undefined;

export default ProductVisibility;
